import React, { useEffect, useRef, useState } from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import StructuredText from "../custom-structured-text-renderer"
import { Asset, Link } from "../../../../plugins/gatsby-plugin-atollon"
import Slider from "react-slick"
import { Arrow } from "../../icons"
import gsap from "gsap"

const CtaSlider = ({ items }) => {
  const [currentSlide, setCurrentSlide] = useState(1)
  const [progress, setProgress] = useState(0)
  const sliderRef = React.useRef(null)
  const progressTween = React.useRef(null)

  const settings = {
    dots: false,
    infinite: true,
    fade: true,
    speed: 500,
    autoPlay: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: currentSlide ? currentSlide - 1 : 0,
    beforeChange: (current, next) => {
      setCurrentSlide(next + 1)
      resetProgress()
    },
  }

  const startProgress = () => {
    progressTween.current = gsap.to({}, {
      duration: 6,
      onUpdate: () => {
        setProgress(progressTween.current.progress() * 100)
      },
      onComplete: () => {
        sliderRef.current.slickNext()
        resetProgress()
      },
    })
  }

  const resetProgress = () => {
    if (progressTween.current) {
      progressTween.current.kill()
    }
    setProgress(0)
  }

  useEffect(() => {
    startProgress()
    return () => {
      if (progressTween.current) {
        progressTween.current.kill()
      }
    }
  }, [currentSlide])

  return (
    <section className="cta-slider">
      <div className="cta-slider__inner">
        {items?.length > 0 &&
          <div className="cta-slider__items">
            <Slider ref={sliderRef} {...settings}>
              {items.map((item, index) => (
                <Link
                  to={item?.link[0].link[0].externalLink ? item?.link[0].link[0].externalLink : item?.link[0].link[0].internalLink.permalink}
                  className={`cta-slider__item${item.testimonial ? ' cta-slider__item--wide' : ''}`} key={index}>
                  {item.backgroundImage && <div className="cta-slider__asset cta-slider__asset--desktop"><Asset asset={item.backgroundImage} /></div>}
                  {(item.mobileImage || item.backgroundImage) && <div className="cta-slider__asset cta-slider__asset--mobile"><Asset asset={item.mobileImage ? item.mobileImage : item.backgroundImage} /></div>}
                  <div className="cta-slider__item-inner">
                    {item.subtitle && <h3>{parse(item.subtitle)}</h3>}
                    <div className="cta-slider__content">
                      {item.title && <h2>{parse(item.title)}</h2>}
                      {item.richContent && <StructuredText data={item.richContent} />}
                      <div className="cta-slider__link">
                        <div className="block">
                          <span className="btn btn--orange">
                            {items?.length > 9 ? '' : '0'}{currentSlide} / {items?.length > 9 ? '' : '0'}{items?.length}
                          </span>
                          <span>{item?.link[0].title}<Arrow /></span>
                          <div 
                            className="progress-bar"
                            style={{ width: `${progress}%` }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </Slider>
          </div>
        }
      </div>
    </section>
  )
}

export default CtaSlider

export const query = graphql`
    fragment CtaSliderProps on DatoCmsCtaSlider {
      ... on DatoCmsCtaSlider {
        id
        items {
          title
          subtitle
          richContent {
            value
          }
          backgroundImage {
            ...InternalAssetProps
          }
          mobileImage {
            ...InternalAssetProps
          }
          link {
            ...LinkWithTitleProps
          }
          testimonial
        }
      }
    }
`
